<template>
  <div :class="classes">
    <pt-page-title :title="currentTitle">
      <router-link slot="before-left" to="/create-report-unscramble-apply"><el-button type="primary">(代/客)提交解读申请</el-button></router-link>
    </pt-page-title>
    <!-- tabs -->
    <!-- <el-tabs v-model="currentStatusFilter" @tab-click="handleClick" slot="title">
      <el-tab-pane label="待解读" name="PENDING_APPROVAL"></el-tab-pane>
      <el-tab-pane label="已解读" name='APPROVED'></el-tab-pane>
    </el-tabs> -->
    <!-- 市场部没有筛选-->
    <pt-page-factor-filter :labels="filterLabels" v-model="filterForm">
      <el-button type="primary" @click="handleFilter">筛选</el-button>
    </pt-page-factor-filter>
    <!-- table -->
    <pt-report-unscramble-table :tableLabels="currentTableLabels" :status="currentStatusFilter">
      <template slot-scope="scope">
        <el-button @click="close(scope.row)" type="text">修改（代/客）</el-button>
        <el-button @click="close(scope.row)" type="text">PDF下载（lab）</el-button>
        <el-button @click="handleReGet(scope.row)" type="text">查看报告（lab）</el-button>
        <el-button @click="close(scope.row)" type="text">提交解读（市场）</el-button>
        <el-button @click="handleReGet(scope.row)" type="text">驳回申请（市场）</el-button>
      </template>
    </pt-report-unscramble-table>
  </div>
</template>

<script>
// 组件class前缀
import { tableLabels, tableLabelsOk, filterFactor } from './report-unscramble-options.js'
import ptReportUnscrambleTable from './pt-report-unscramble-table/withData'
const prefixCls = 'pt-gene-report-order'
export default {
  name: 'pt-gene-report-order',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    currentTableLabels () {
      if (this.currentStatusFilter === 'PENDING_APPROVAL') {
        return tableLabels
      }
      return tableLabelsOk
    }
  },
  data () {
    return {
      currentTitle: '基因报告解读工单/基因报告解读申请',
      filterLabels: filterFactor,
      loading: false,
      currentStatusFilter: this.$route.params.status,
      // 筛选表单
      filterForm: {}
    }
  },
  components: {
    ptReportUnscrambleTable
  },
  methods: {
    handleClick (tab) {
      this.$router.push({ name: 'gene-report-order', params: { status: tab.name } })
    },
    handleFilter () {
      this.$refs.table.reload(this.filterForm)
    }
  }
}
</script>

<style  lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-gene-report-order{
  .el-tabs{
    display: inline-block;
  }
  .el-tabs--top .el-tabs__nav{
    padding-left:30px;
    padding-right:30px;
    .el-tabs__item{
      font-size: 16px;
    }
  }
  .el-tabs__active-bar{
    left:30px;
  }
}
</style>
